import { useState } from 'react';
import { Icon } from '@plone/volto/components/';
import { BodyClass } from '@plone/volto/helpers/';
import GlobalSearchPanel from '@fhnw/components/GlobalSearch/GlobalSearchPanel';
import zoomSVG from '@plone/volto/icons/zoom.svg';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  search: {
    id: 'Open Global Search',
    defaultMessage: 'Open Global Search',
  },
  overlay: {
    id: 'Overlay',
    defaultMessage: 'Overlay',
  },
});

const GlobalSearch = () => {
  const [openGlobalSearch, setOpenGlobalSearch] = useState(false);
  const intl = useIntl();

  const onOpenGlobalSearch = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ): void => {
    e.stopPropagation();
    setOpenGlobalSearch(true);
  };

  const closeGlobalSearch = (): void => {
    setOpenGlobalSearch(false);
  };

  // Auto-open search panel when screen reader users jump directly to search input
  const handleContainerFocus = (event: React.FocusEvent) => {
    if (
      event.target instanceof HTMLElement &&
      event.target.id === 'searchbar-input'
    ) {
      setOpenGlobalSearch(true);
    }
  };

  return (
    <div
      className="global-search-container"
      onFocusCapture={handleContainerFocus}
    >
      {/* Hidden search input for accessibility - always present for screen readers */}
      <input
        id="searchbar-input"
        type="text"
        className="visually-hidden"
        placeholder={intl.formatMessage(messages.search)}
        onFocus={() => {
          setOpenGlobalSearch(true);
          // Transfer focus to the actual search input after panel opens
          setTimeout(() => {
            const actualSearchInput = document.getElementById(
              'searchbar-input-panel',
            );
            if (actualSearchInput) {
              actualSearchInput.focus();
            }
          }, 100);
        }}
        tabIndex={-1}
        aria-label={intl.formatMessage(messages.search)}
      />
      <div className="global-search-icon-container">
        <button onClick={onOpenGlobalSearch}>
          <Icon className="global-search-icon" name={zoomSVG} size="22px" />{' '}
          <span className="visually-hidden">
            {intl.formatMessage(messages.search)}
          </span>
        </button>
      </div>
      {openGlobalSearch && (
        <>
          <BodyClass className="prevent-scroll" />
          <div className="overlay">
            <span className="visually-hidden">
              {intl.formatMessage(messages.overlay)}
            </span>
          </div>
        </>
      )}
      <div
        className={cx('global-search-content-container', {
          'is-open': openGlobalSearch,
        })}
        style={{ transform: 'translateX(100%)' }}
      >
        {openGlobalSearch && (
          <GlobalSearchPanel
            closeGlobalSearch={closeGlobalSearch}
            isMobile={false}
          />
        )}
      </div>
    </div>
  );
};

export default GlobalSearch;
